import { useBloc } from "@blac/react";
import React from "react";
import AppointmentsBloc from "src/state/AppointmentsBloc/AppointmentsBloc";
import {
  AppPopup,
  AppQueryPopupsController
} from "../AppQueryPopups/AppQueryPopupsBloc";
import {
  DebugBadge,
  DebugButton,
  DebugButtonRow,
  DebugDivider,
  DebugKeyValue
} from "./debug.styles";

const DebugAppointmentScheduler = () => {
  const [{ scheduledAppointments }, { loadAppointments }] =
    useBloc(AppointmentsBloc);

  return (
    <div>
      <DebugButtonRow>
        <DebugButton
          onClick={() => {
            AppQueryPopupsController.openPopup(AppPopup.scheduleAppointment, {
              additionalParameters: {
                type: "SYNC_VISIT"
              }
            });
          }}
        >
          Open Scheduler
        </DebugButton>
        <DebugButton onClick={() => void loadAppointments()}>
          Refresh List
        </DebugButton>
      </DebugButtonRow>

      {scheduledAppointments.length > 0 && (
        <>
          <DebugDivider />
          <h4
            style={{ fontSize: "13px", margin: "0 0 0.75rem", fontWeight: 600 }}
          >
            Upcoming ({scheduledAppointments.length})
          </h4>
          {scheduledAppointments.map((appointment) => (
            <div
              key={appointment.id}
              style={{
                border: "1px solid #e0e0e0",
                borderRadius: "8px",
                padding: "0.75rem",
                marginBottom: "0.5rem"
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "0.5rem"
                }}
              >
                <DebugBadge variant="info">{appointment.type}</DebugBadge>
                <code style={{ fontSize: "10px", color: "#666" }}>
                  {appointment.id.slice(0, 8)}...
                </code>
              </div>
              <DebugKeyValue style={{ padding: "0.25rem 0" }}>
                <span className="key" style={{ minWidth: "80px" }}>
                  Starts
                </span>
                <span className="value" style={{ fontSize: "12px" }}>
                  {new Date(appointment.start).toLocaleString()}
                </span>
              </DebugKeyValue>
              <DebugKeyValue style={{ padding: "0.25rem 0" }}>
                <span className="key" style={{ minWidth: "80px" }}>
                  Ends
                </span>
                <span className="value" style={{ fontSize: "12px" }}>
                  {new Date(appointment.end).toLocaleString()}
                </span>
              </DebugKeyValue>
              <DebugKeyValue style={{ padding: "0.25rem 0" }}>
                <span className="key" style={{ minWidth: "80px" }}>
                  Attendees
                </span>
                <span className="value">{appointment.participants.length}</span>
              </DebugKeyValue>
              <DebugButton
                className="small"
                style={{ marginTop: "0.5rem" }}
                onClick={() => {
                  AppQueryPopupsController.openPopup(
                    AppPopup.scheduleAppointment,
                    {
                      additionalParameters: {
                        reschedule: appointment.id
                      }
                    }
                  );
                }}
              >
                Reschedule
              </DebugButton>
            </div>
          ))}
        </>
      )}

      {scheduledAppointments.length === 0 && (
        <p
          style={{
            color: "#666",
            fontSize: "13px",
            marginTop: "0.75rem"
          }}
        >
          No upcoming appointments
        </p>
      )}
    </div>
  );
};

export default DebugAppointmentScheduler;
